import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import isEmpty from 'lodash/isEmpty'
import startCase from 'lodash/startCase'
import { TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const ShareBoard = ({errors, ctaClass, lead, getTranslation}) => {
  const namePresent = !isEmpty(lead.name) && !isEmpty(lead.last_name)
  const showLeadDetails = lead.anon_guest || !namePresent

  return (
    <section className={`share-board-form-fields ${ctaClass}`}>
      { showLeadDetails && (
        <div className="lead-details">
          <div>
            <h1>{getTranslation(TRANSLATION_VALUE_KEYS.senderDetails)}</h1>
            <div className="input-field-container first-name">
              <label className="field-label">{startCase(getTranslation(TRANSLATION_VALUE_KEYS.firstName))}</label>
              <Field
                className={`${errors.name ? 'error' : ''}`}
                name="name"
                component="input"
                type="text"
                autoFocus={true}
                tabIndex={TAB_INDEXES.ShareBoardInputField}
                placeholder={getTranslation(TRANSLATION_VALUE_KEYS.firstName)} />
            </div>
            <div className="input-field-container last-name">
              <label className="field-label">{startCase(getTranslation(TRANSLATION_VALUE_KEYS.lastName))}</label>
              <Field
                className={`${errors.last_name ? 'error' : ''}`}
                name="last_name"
                component="input"
                type="text"
                tabIndex={TAB_INDEXES.ShareBoardInputField}
                placeholder={getTranslation(TRANSLATION_VALUE_KEYS.lastName)} />
            </div>
          </div>
          <div className="input-field-container">
            <label className="field-label">{getTranslation(TRANSLATION_VALUE_KEYS.email)}</label>
            <Field
              className={`${errors.email ? 'error' : ''}`}
              name="email"
              component="input"
              type="email"
              tabIndex={TAB_INDEXES.ShareBoardInputField}
              placeholder={`* ${getTranslation(TRANSLATION_VALUE_KEYS.yourEmailHere)}`} />
          </div>
        </div>
      )}
      <div className="input-field-container">
        <label className="field-label">{getTranslation(TRANSLATION_VALUE_KEYS.to)}</label>
        <Field
          className={`${errors.invitee ? 'error' : ''}`}
          name="invitee"
          component="input"
          type="email"
          tabIndex={TAB_INDEXES.ShareBoardInputField}
          autoFocus={!showLeadDetails}
          placeholder={`* ${getTranslation(TRANSLATION_VALUE_KEYS.shareEmailHere)}`} />
      </div>
    </section>
  )
}

ShareBoard.propTypes = {
  errors: PropTypes.object,
  ctaClass: PropTypes.string,
}

export default withTranslation(TRANSLATION_KEYS.ctaShareBoard)(ShareBoard)
